import { getMessage } from "../../../../services/graphql/queries/messageConfiguration";
import { withApollo } from "react-apollo";
import React from "react";
import { SET_TIMEOUT_VALUE } from "../../../../constants/app-constants";
import { withRouter } from "react-router-dom";
import ReactModal from "../../../Common/ReactModal";
import Success from "../../../../static/images/svg/Success.svg";
class EmailView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: "",
      priority: "",
      message: {},
      msgTemplate: "",
      Id: "",
      reactModalVisible: false,
      modalMessage: "You dont have permission to do this Action",
      Message_Configuration_Email_Feature_ID: 176
    };
    this.getData = this.getData.bind(this);
    this.changeMode = this.changeMode.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }

  getData() {
    console.log("AppView", this.props.message);
    this.props.client
      .query({
        query: getMessage,
        variables: {
          messageId: parseInt(this.state.Id),
          deliveryMode: "EMAIL"
        },

        fetchPolicy: "network-only"
      })
      .then(result => {
        const message = result.data.getMessage;
        console.log("result~~~~", message);

        this.setState({ ...message });
        this.props.emailData(message);
      })
      .catch(error => {
        error.graphQLErrors.map(({ message }, i) => {
          this.setState(prevState => {
            return { errors: [message] };
          });
        });
        setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }
  componentWillReceiveProps(nextProps) {
    console.log("props", nextProps);
    if (nextProps.message && nextProps.message.Id) {
      this.state.Id = nextProps.message.Id;
      // this.getData();
    }
  }
  submitModal() {
    this.setState({ reactModalVisible: false });
  }
  componentDidMount() {
    if (this.props.message && this.props.message.Id) {
      this.state.Id = this.props.message.Id;
      this.getData();
    }
  }
  changeMode() {
    if (
      this.props.accessSpecifier[
        this.state.Message_Configuration_Email_Feature_ID
      ].editP
    ) {
      this.props.toggleMode(true);
    } else {
      this.setState({ reactModalVisible: true });
    }
  }
  render() {
    const {
      message,
      priority,
      subject,
      msgTemplate,
      reactModalVisible,
      modalMessage
    } = this.state;
    console.log("email,", priority);
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={false}
        />
        <div
          className="tab-pane fade show active"
          id="msg"
          role="tabpanel"
          aria-labelledby="msg-tab"
        >
          <div className="box-card">
            <div className="row align-items-center">
              <div className="col">
                <h1 className="heading m-b-0">Mail Details</h1>
              </div>
            </div>
            <div className="alert alert-success p-0 m-t-10 m-b-0" role="alert">
              {this.props && this.props.isSuccess ? (
                <span>
                  <img src={Success} />
                  Success
                </span>
              ) : null}
            </div>
            <div className="row mt-3">
              <div className="col-md-12 col-lg-12">
                <div className="row">
                  <div className="col-md-12 col-lg-4">
                    <div className="form-group">
                      <label>
                        Subject<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        readOnly
                        className="form-control-plaintext"
                        value={subject}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-3">
                    <div className="form-group">
                      <label>
                        Priority<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        readOnly
                        className="form-control-plaintext"
                        value={this.state.priority}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                      <label>
                        Message<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        type="text"
                        readOnly
                        data-autoresize
                        className="form-control-plaintext text-medium"
                        id="textarea"
                        value={msgTemplate}
                      />
                    </div>
                    <br />
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={this.changeMode}
                    >
                      Modify
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withApollo(EmailView);
